import React, { useContext, useEffect, useState } from "react";
import "./index.css";
import { Image } from "../../assests/images";

import { NavLink } from "react-router-dom";
import { RxCrossCircled } from "react-icons/rx";
import Progress from "../progress/Progress";
import { Context } from "../../context/Context";
import { pointContext } from "../../context/dappContext";
import Alert from "../alert/Alert";
const SideMenu = ({ show, setShow }) => {
	const getCurrentYear = new Date().getFullYear();

	const {
		connectWallet,
		address,
		isConnected,
		disconnectWallet,
		showMessage,
		setShowMessage,
		message,
		setMessage,
		isError,
		setIsError,
		userPoints,
		getPoints,
	} = useContext(Context);
	const {
		profileData,
		setProfileData,
		loading,
		setLoading,
		AllPoints,
		setAllPoints,
		getProfileData,
		getAllPoints,
		removeFromStake,
	} = useContext(pointContext);
	const fetchProfileData = async () => {
		try {
			setLoading(true);
			const result = await getProfileData();
			if (result.success) {
				setProfileData(result.data);
				setMessage(result.message);
				setIsError(false);
			} else {
				setMessage(result.message);
				setIsError(true);
			}
		} catch (error) {
			console.error("Error fetching data:", error);
			setMessage("Error fetching data");
			setIsError(true);
		} finally {
			setLoading(false);
		}
	};

	const allPoints = async () => {
		try {
			const result = await getAllPoints();
			if (result.success) {
				setAllPoints(result.points);
				setMessage(result.message);
				setIsError(false);
			} else {
				setMessage(result.message);
				setIsError(true);
			}
		} catch (error) {
			console.error("Error fetching data:", error);
			setMessage("Error fetching data");
			setIsError(true);
		}
	};

	// const connectAndLogin = async (user) => {
	//   try {
	//     // Call the registerOrLoginUser function
	//     const result = await registerOrLoginUser(user);

	//     if (result.success) {
	//       // Display a success message
	//       setMessage(result.message);
	//       setIsError(false);
	//     } else {
	//       // Display an error message
	//       setMessage(result.message);
	//       setIsError(true);
	//     }
	//   } catch (error) {
	//     console.error("Error connecting and logging in:", error);
	//     // Display an error message
	//     setMessage("Error connecting and logging in");
	//     setIsError(true);
	//   }
	// };
	//   useEffect(() => {
	// 	if (isConnected && address) {
	// 	  // Show a message when the wallet is connected
	// 	  setShowMessage(true);

	// 	  // Call the registerOrLoginUser function when the wallet is connected
	// 	  const user = {
	// 		walletAddress: address,
	// 	  };
	// 	  connectAndLogin(user);
	// 	} else {
	// 	  // Hide the message when the wallet is disconnected
	// 	  setShowMessage(false);
	// 	}
	//   }, [isConnected, address]);
	// useEffect(() => {
	//   if (isConnected) {
	//     setLoading(true); // Set loading to true before starting fetch operations
	//     Promise.all([fetchProfileData()])
	//       .then(() => {
	//         setIsError(false);
	//       })
	//       .catch(() => {
	//         setIsError(true);
	//       })
	//       .finally(() => {
	//         setLoading(false); // Set loading to false after both fetch operations are complete
	//       });
	//   }
	//   allPoints();
	// }, [isConnected]);

	const totalStaked = isConnected && profileData && profileData?.total_stake;
	const totalPointsPerDay = totalStaked && totalStaked * 1440;

	const isDisabled = true;

	return (
		<aside className={show ? `sidemenu_section hide` : `sidemenu_section`}>
			<nav className={show ? "sidemenu_container hide" : "sidemenu_container"}>
				<div className="cross_btn" onClick={() => setShow(!show)}>
					{/* <ImCross /> */}
					<RxCrossCircled />
				</div>
				<div className="sidemenu_logo_container">
					<img src={Image.logo} alt="logo" />
				</div>
				<div className="sidemenu_body">
					<div className="sidemenu_list">
						<ul>
							<NavLink
								to="/"
								className="menu_items"
								onClick={() => setShow(!show)}
							>
								<li className="list">
									<span className="icon">
										{/* <svg
                      width="10"
                      height="19"
                      viewBox="0 0 10 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="nav_icon"
                    >
                      <path d="M3.84467 4.71531V1.02534H6.73014V4.71531C6.79356 5.07772 7.05262 5.08173 7.55456 5.24245C8.85461 5.76959 9.3037 6.44586 9.29852 7.58162V17.4655C9.2336 17.7105 9.1324 17.7524 8.95439 17.826L8.94973 17.8279H1.59337C1.43928 17.74 1.36028 17.6615 1.24457 17.4655V7.58162C1.21362 6.57342 1.41676 6.0983 2.63975 5.37423C3.30563 5.11066 3.81297 5.04477 3.84467 4.71531Z" />
                    </svg> */}

										<svg
											width="29"
											height="28"
											viewBox="0 0 29 28"
											fill="none"
											className="nav_icon"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path d="M12.8447 8.71531V5.02534H15.7301V8.71531C15.7936 9.07772 16.0526 9.08173 16.5546 9.24245C17.8546 9.76959 18.3037 10.4459 18.2985 11.5816V21.4655C18.2336 21.7105 18.1324 21.7524 17.9544 21.826L17.9497 21.8279H10.5934C10.4393 21.74 10.3603 21.6615 10.2446 21.4655V11.5816C10.2136 10.5734 10.4168 10.0983 11.6398 9.37423C12.3056 9.11066 12.813 9.04477 12.8447 8.71531Z" />
											<path d="M27.8697 13.9208C27.8697 21.278 21.7899 27.2582 14.2702 27.2582C6.75048 27.2582 0.670654 21.278 0.670654 13.9208C0.670654 6.56357 6.75048 0.58342 14.2702 0.58342C21.7899 0.58342 27.8697 6.56357 27.8697 13.9208Z" />
										</svg>

										{/* <RiNftLine className="icon-style" /> */}
									</span>
									<span className="text">
										<span className="light_weight">my</span> nfts
									</span>
								</li>
							</NavLink>

							<NavLink
								to="/staking"
								className="menu_items leaderboard"
								onClick={() => setShow(!show)}
							>
								<li className="list">
									<span className="icon">
										<svg
											width="28"
											height="28"
											viewBox="0 0 28 28"
											fill="none"
											className="nav_icon"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path d="M27.5 13.9916C27.5 21.3521 21.4614 27.3289 14 27.3289C6.53863 27.3289 0.5 21.3521 0.5 13.9916C0.5 6.63101 6.53863 0.654171 14 0.654171C21.4614 0.654171 27.5 6.63101 27.5 13.9916Z" />
											<path
												d="M9.33333 20.9102H11.6667M16.3333 20.9102H18.6667M18.2778 9.76346V15.9134M7 9.53284L7 16.144C7 17.0051 7 17.4356 7.16955 17.7645C7.31868 18.0538 7.55665 18.289 7.84935 18.4364C8.1821 18.604 8.6177 18.604 9.48889 18.604L18.5111 18.604C19.3823 18.604 19.8179 18.604 20.1507 18.4364C20.4433 18.289 20.6813 18.0538 20.8305 17.7645C21 17.4356 21 17.0051 21 16.144V9.53284C21 8.67176 21 8.24123 20.8305 7.91234C20.6813 7.62304 20.4433 7.38784 20.1507 7.24043C19.8179 7.07286 19.3823 7.07286 18.5111 7.07286L9.48889 7.07286C8.6177 7.07286 8.1821 7.07286 7.84935 7.24043C7.55665 7.38784 7.31868 7.62304 7.16955 7.91234C7 8.24123 7 8.67176 7 9.53284ZM13.6111 12.8384C13.6111 13.8998 12.7406 14.7603 11.6667 14.7603C10.5928 14.7603 9.72222 13.8998 9.72222 12.8384C9.72222 11.777 10.5928 10.9166 11.6667 10.9166C12.7406 10.9166 13.6111 11.777 13.6111 12.8384Z"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
									</span>
									<span className="text">staking</span>
								</li>
								{typeof totalPointsPerDay !== "undefined" &&
								totalPointsPerDay > 0 ? (
									<>
										{isConnected && (
											<li className="total_points">
												<span className="icon">
													<svg
														width="14"
														height="12"
														viewBox="0 0 14 12"
														fill="none"
														className="child_nav_icon"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															d="M1.2127 4.38488H12.7873M5.78162 1.03801L4.56324 4.38488L7 10.7997L9.43676 4.38488L8.21838 1.03801M7.37439 10.6672L12.8319 4.67056C12.9244 4.56893 12.9706 4.51812 12.9883 4.46139C13.0039 4.41138 13.0039 4.35838 12.9883 4.30837C12.9706 4.25164 12.9244 4.20083 12.8319 4.0992L10.1921 1.19858C10.1384 1.13956 10.1115 1.11005 10.0786 1.08883C10.0494 1.07004 10.0169 1.05608 9.98242 1.04759C9.94354 1.03801 9.90159 1.03801 9.81769 1.03801H4.18231C4.09841 1.03801 4.05646 1.03801 4.01758 1.04759C3.98314 1.05608 3.95058 1.07004 3.92141 1.08883C3.88849 1.11005 3.86163 1.13956 3.80792 1.19858L1.1681 4.0992C1.0756 4.20083 1.02936 4.25164 1.01169 4.30837C0.996105 4.35838 0.996105 4.41138 1.01169 4.46139C1.02936 4.51812 1.0756 4.56893 1.1681 4.67056L6.62561 10.6672C6.75418 10.8085 6.81847 10.8791 6.89543 10.9049C6.96296 10.9275 7.03704 10.9275 7.10457 10.9049C7.18153 10.8791 7.24582 10.8085 7.37439 10.6672Z"
															stroke-linecap="round"
															stroke-linejoin="round"
														/>
													</svg>
													{/* <GoPersonFill /> */}
												</span>
												<span className="text">{`+${(
													totalPointsPerDay / 1000
												).toFixed(2)}K / day`}</span>
											</li>
										)}
									</>
								) : (
									<>
										{isConnected &&
											profileData &&
											Number(profileData?.total_stake) > 0 && (
												<li className="total_points">
													<span className="icon">
														<svg
															width="14"
															height="12"
															viewBox="0 0 14 12"
															fill="none"
															className="child_nav_icon"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																d="M1.2127 4.38488H12.7873M5.78162 1.03801L4.56324 4.38488L7 10.7997L9.43676 4.38488L8.21838 1.03801M7.37439 10.6672L12.8319 4.67056C12.9244 4.56893 12.9706 4.51812 12.9883 4.46139C13.0039 4.41138 13.0039 4.35838 12.9883 4.30837C12.9706 4.25164 12.9244 4.20083 12.8319 4.0992L10.1921 1.19858C10.1384 1.13956 10.1115 1.11005 10.0786 1.08883C10.0494 1.07004 10.0169 1.05608 9.98242 1.04759C9.94354 1.03801 9.90159 1.03801 9.81769 1.03801H4.18231C4.09841 1.03801 4.05646 1.03801 4.01758 1.04759C3.98314 1.05608 3.95058 1.07004 3.92141 1.08883C3.88849 1.11005 3.86163 1.13956 3.80792 1.19858L1.1681 4.0992C1.0756 4.20083 1.02936 4.25164 1.01169 4.30837C0.996105 4.35838 0.996105 4.41138 1.01169 4.46139C1.02936 4.51812 1.0756 4.56893 1.1681 4.67056L6.62561 10.6672C6.75418 10.8085 6.81847 10.8791 6.89543 10.9049C6.96296 10.9275 7.03704 10.9275 7.10457 10.9049C7.18153 10.8791 7.24582 10.8085 7.37439 10.6672Z"
																stroke-linecap="round"
																stroke-linejoin="round"
															/>
														</svg>
														{/* <GoPersonFill /> */}
													</span>
													<span className="text">+1440 / day</span>
												</li>
											)}
									</>
								)}
							</NavLink>

							<NavLink
								to="/leaderboards"
								className="menu_items leaderboard"
								onClick={() => setShow(!show)}
							>
								<li className="list">
									<span className="icon">
										<svg
											width="28"
											height="28"
											viewBox="0 0 28 28"
											fill="none"
											className="nav_icon"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M14 16.1728C11.6804 16.1728 9.8 14.3142 9.8 12.0215V8.17783C9.8 7.8915 9.8 7.74833 9.84222 7.6337C9.91298 7.44152 10.0661 7.29013 10.2606 7.22018C10.3766 7.17846 10.5214 7.17846 10.8111 7.17846H17.1889C17.4786 7.17846 17.6234 7.17846 17.7394 7.22018C17.9339 7.29013 18.087 7.44152 18.1578 7.6337C18.2 7.74833 18.2 7.8915 18.2 8.17783V12.0215C18.2 14.3142 16.3196 16.1728 14 16.1728ZM14 16.1728V18.2484M18.2 8.5622H19.95C20.2762 8.5622 20.4392 8.5622 20.5679 8.61486C20.7394 8.68508 20.8757 8.81977 20.9467 8.9893C21 9.11645 21 9.27763 21 9.6V9.94594C21 10.5894 21 10.9111 20.9284 11.175C20.7343 11.8913 20.1682 12.4508 19.4435 12.6427C19.1765 12.7134 18.851 12.7134 18.2 12.7134M9.8 8.5622H8.05C7.72384 8.5622 7.56076 8.5622 7.43212 8.61486C7.2606 8.68508 7.12433 8.81977 7.05328 8.9893C7 9.11645 7 9.27763 7 9.6V9.94594C7 10.5894 7 10.9111 7.07156 11.175C7.26574 11.8913 7.83179 12.4508 8.55648 12.6427C8.82353 12.7134 9.14902 12.7134 9.8 12.7134M10.8111 21.0158H17.1889C17.3607 21.0158 17.5 20.8782 17.5 20.7083C17.5 19.3497 16.3857 18.2484 15.0111 18.2484H12.9889C11.6143 18.2484 10.5 19.3497 10.5 20.7083C10.5 20.8782 10.6393 21.0158 10.8111 21.0158Z"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path d="M27.5 14.0971C27.5 21.4577 21.4614 27.4345 14 27.4345C6.53863 27.4345 0.5 21.4577 0.5 14.0971C0.5 6.73661 6.53863 0.759766 14 0.759766C21.4614 0.759766 27.5 6.73661 27.5 14.0971Z" />
										</svg>
										{/* <GiTrophyCup className="icon-style" /> */}
									</span>
									<span className="text">leaderboards</span>
								</li>
								<li className="total_points" onClick={() => getPoints()}>
									<span className="icon">
										<svg
											width="16"
											height="16"
											viewBox="0 0 16 16"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											className="child_nav_icon"
										>
											<path
												d="M3.32141 13.0643C3.74723 12.0611 4.74145 11.3574 5.9 11.3574H10.1C11.2586 11.3574 12.2528 12.0611 12.6786 13.0643M10.8 6.10742C10.8 7.65382 9.5464 8.90742 8 8.90742C6.4536 8.90742 5.2 7.65382 5.2 6.10742C5.2 4.56102 6.4536 3.30742 8 3.30742C9.5464 3.30742 10.8 4.56102 10.8 6.10742ZM15 7.85742C15 11.7234 11.866 14.8574 8 14.8574C4.13401 14.8574 1 11.7234 1 7.85742C1 3.99143 4.13401 0.857422 8 0.857422C11.866 0.857422 15 3.99143 15 7.85742Z"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
										{/* <GoPersonFill /> */}
									</span>
									{/* <span className="text">{userPoints}</span> */}
									<span className="text">
										{Number(AllPoints) > 0 ? Number(AllPoints) : 0}
									</span>
								</li>
							</NavLink>

							<button
								// href="https://mint.degendistillery.com/"
								// target="_blank"
								className="menu_items"
								onClick={() => setShow(!show)}
								// rel="noreferrer"
								disabled={true}
							>
								<li className={`list ${isDisabled ? "disabled" : ""}`}>
									<span className="icon">
										<svg
											width="27"
											height="27"
											viewBox="0 0 27 27"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
											className={`nav_icon ${isDisabled ? "disabled" : ""}`}
										>
											<path
												d="M6.625 17.9862L13.5002 21.0749L20.375 17.9862M26 13.6621C26 20.4854 20.4036 26.0169 13.5 26.0169C6.59644 26.0169 1 20.4854 1 13.6621C1 6.83869 6.59644 1.30725 13.5 1.30725C20.4036 1.30725 26 6.83869 26 13.6621ZM6.625 13.0443L13.5002 16.133L20.375 13.0443L13.5002 5.01369L6.625 13.0443Z"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
										</svg>
										{/* <SiLinuxmint className="icon-style" /> */}
									</span>
									<span className="text">
										{/* <span className="light_weight">MINT</span> ORIGO */}
										Marketplace
									</span>
								</li>
							</button>

							<button
								className="menu_items"
								onClick={() => setShow(!show)}
								disabled={true}
							>
								<li className={`list ${isDisabled ? "disabled" : ""}`}>
									<span className="icon">
										<svg
											width="25"
											height="26"
											viewBox="0 0 25 26"
											fill="none"
											className={`nav_icon ${isDisabled ? "disabled" : ""}`}
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												d="M6.25 6.56705H7.07093C7.22555 6.56705 7.30286 6.56705 7.36508 6.59499C7.41991 6.61962 7.46637 6.65923 7.49893 6.70909C7.53587 6.76568 7.54681 6.8409 7.56868 6.99135L7.86615 9.03801M7.86615 9.03801L8.52726 13.814C8.61116 14.4201 8.65311 14.7231 8.80053 14.9512C8.93042 15.1522 9.11665 15.3121 9.3368 15.4115C9.58663 15.5243 9.89779 15.5243 10.5201 15.5243H15.8988C16.4912 15.5243 16.7874 15.5243 17.0294 15.4195C17.2429 15.3272 17.4259 15.1782 17.5582 14.9895C17.7082 14.7753 17.7636 14.4894 17.8744 13.9174L18.7064 9.62467C18.7454 9.42336 18.7649 9.3227 18.7366 9.24402C18.7118 9.175 18.6629 9.11688 18.5985 9.08003C18.5252 9.03801 18.4209 9.03801 18.2124 9.03801H7.86615ZM11.278 18.3041C11.278 18.6453 10.9966 18.9219 10.6495 18.9219C10.3024 18.9219 10.021 18.6453 10.021 18.3041C10.021 17.9629 10.3024 17.6864 10.6495 17.6864C10.9966 17.6864 11.278 17.9629 11.278 18.3041ZM16.306 18.3041C16.306 18.6453 16.0246 18.9219 15.6775 18.9219C15.3304 18.9219 15.049 18.6453 15.049 18.3041C15.049 17.9629 15.3304 17.6864 15.6775 17.6864C16.0246 17.6864 16.306 17.9629 16.306 18.3041Z"
												stroke-linecap="round"
												stroke-linejoin="round"
											/>
											<path d="M24.5 12.7445C24.5 19.2862 19.1329 24.5993 12.5 24.5993C5.86706 24.5993 0.5 19.2862 0.5 12.7445C0.5 6.20272 5.86706 0.889648 12.5 0.889648C19.1329 0.889648 24.5 6.20272 24.5 12.7445Z" />
										</svg>

										{/* <MdOutlineLocalGroceryStore className="icon-style" /> */}
									</span>
									<span className="text">store</span>
								</li>
							</button>
						</ul>
					</div>

					<div className="sidemenu_list-footer">
						{showMessage && (
							<div style={{ width: "100%" }}>
								{/* <Alert message={message}/> */}

								{/* <p>{message}</p> */}
								{/* You can add additional content or messages here */}
							</div>
						)}

						{isConnected && Object.keys(profileData).length > 0 && (
							<Progress profileData={profileData} />
						)}
						{/* {isConnected ? (
              <button className="btn" onClick={disconnectWallet}>
                {address.slice(0, 7) + "..." + address.slice(-5, -1)}
              </button>
            ) : (
              <button className="btn" onClick={connectWallet}>
                Connect Wallet
              </button>
            )} */}
						{!isConnected && !address && (
							<button className="btn" onClick={connectWallet}>
								Connect Wallet
							</button>
						)}

						<div className="social_icons">
							<a
								className="box"
								href="https://www.instagram.com/degendistillery/"
								target="_blank"
							>
								<svg
									width="28"
									height="27"
									viewBox="0 0 28 27"
									fill="none"
									className="social_icon"
									xmlns="http://www.w3.org/2000/svg"
								>
									<g clip-path="url(#clip0_58_224)">
										<path
											d="M13.9972 3.01397C17.5405 3.01397 17.9601 3.02933 19.3536 3.09077C20.6487 3.1471 21.348 3.36214 21.8142 3.54134C22.4307 3.77686 22.8762 4.06359 23.3372 4.51927C23.8034 4.98008 24.0883 5.41528 24.3266 6.02457C24.5079 6.48538 24.7255 7.1817 24.7825 8.4566C24.8446 9.83902 24.8602 10.2537 24.8602 13.7507C24.8602 17.2529 24.8446 17.6676 24.7825 19.0449C24.7255 20.3249 24.5079 21.0161 24.3266 21.4769C24.0883 22.0862 23.7982 22.5265 23.3372 22.9822C22.871 23.443 22.4307 23.7246 21.8142 23.9601C21.348 24.1393 20.6435 24.3544 19.3536 24.4107C17.9549 24.4722 17.5353 24.4875 13.9972 24.4875C10.454 24.4875 10.0344 24.4722 8.64088 24.4107C7.34582 24.3544 6.64649 24.1393 6.18027 23.9601C5.56382 23.7246 5.11832 23.4379 4.65728 22.9822C4.19106 22.5214 3.90614 22.0862 3.66785 21.4769C3.48654 21.0161 3.26897 20.3198 3.21199 19.0449C3.14983 17.6625 3.13429 17.2477 3.13429 13.7507C3.13429 10.2486 3.14983 9.8339 3.21199 8.4566C3.26897 7.17658 3.48654 6.48538 3.66785 6.02457C3.90614 5.41528 4.19624 4.97496 4.65728 4.51927C5.1235 4.05847 5.56382 3.77686 6.18027 3.54134C6.64649 3.36214 7.351 3.1471 8.64088 3.09077C10.0344 3.02933 10.454 3.01397 13.9972 3.01397ZM13.9972 0.653625C10.397 0.653625 9.9463 0.668986 8.53209 0.730426C7.12307 0.791867 6.15436 1.01715 5.31517 1.33971C4.43971 1.67764 3.69893 2.12308 2.96334 2.85525C2.22257 3.5823 1.77189 4.31447 1.42999 5.17464C1.10364 6.00921 0.875706 6.96154 0.813543 8.3542C0.751381 9.75709 0.73584 10.2025 0.73584 13.761C0.73584 17.3194 0.751381 17.7649 0.813543 19.1626C0.875706 20.5553 1.10364 21.5128 1.42999 22.3422C1.77189 23.2075 2.22257 23.9397 2.96334 24.6667C3.69893 25.3938 4.43971 25.8443 5.30999 26.1771C6.15436 26.4997 7.11789 26.725 8.52691 26.7864C9.94112 26.8479 10.3918 26.8632 13.9921 26.8632C17.5923 26.8632 18.043 26.8479 19.4572 26.7864C20.8662 26.725 21.8349 26.4997 22.6741 26.1771C23.5444 25.8443 24.2852 25.3938 25.0208 24.6667C25.7564 23.9397 26.2122 23.2075 26.5489 22.3473C26.8753 21.5128 27.1032 20.5604 27.1654 19.1678C27.2276 17.77 27.2431 17.3245 27.2431 13.7661C27.2431 10.2077 27.2276 9.76222 27.1654 8.36444C27.1032 6.97178 26.8753 6.01433 26.5489 5.18488C26.2226 4.31447 25.7719 3.5823 25.0311 2.85525C24.2955 2.1282 23.5548 1.67764 22.6845 1.34483C21.8401 1.02227 20.8766 0.796987 19.4676 0.735546C18.0482 0.668986 17.5975 0.653625 13.9972 0.653625Z"
											// fill="white"
										/>
										<path
											d="M13.9971 7.02808C10.2362 7.02808 7.18506 10.0438 7.18506 13.761C7.18506 17.4781 10.2362 20.4938 13.9971 20.4938C17.7579 20.4938 20.8091 17.4781 20.8091 13.761C20.8091 10.0438 17.7579 7.02808 13.9971 7.02808ZM13.9971 18.1284C11.5572 18.1284 9.57833 16.1725 9.57833 13.761C9.57833 11.3494 11.5572 9.39354 13.9971 9.39354C16.437 9.39354 18.4158 11.3494 18.4158 13.761C18.4158 16.1725 16.437 18.1284 13.9971 18.1284Z"
											// fill="white"
										/>
										<path
											d="M22.6689 6.7618C22.6689 7.63221 21.9541 8.33366 21.0786 8.33366C20.198 8.33366 19.4883 7.62709 19.4883 6.7618C19.4883 5.89139 20.2032 5.18994 21.0786 5.18994C21.9541 5.18994 22.6689 5.89651 22.6689 6.7618Z"
											// fill="white"
										/>
									</g>
									<defs>
										<clipPath id="clip0_58_224">
											<rect
												width="26.5228"
												height="26.2147"
												// fill="white"
												transform="translate(0.73584 0.653625)"
											/>
										</clipPath>
									</defs>
								</svg>
								{/* <img src={Image.instagram} alt="instagram" /> */}
							</a>
							<a
								className="box"
								href="https://discord.com/invite/degendistillery"
								target="_blank"
							>
								<svg
									width="27"
									height="20"
									viewBox="0 0 27 20"
									className="social_icon"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M22.475 2.01539C20.8298 1.29031 19.0656 0.756099 17.221 0.450136C17.1874 0.444231 17.1539 0.458988 17.1366 0.488502C16.9097 0.876119 16.6584 1.3818 16.4824 1.77926C14.4984 1.49396 12.5246 1.49396 10.5813 1.77926C10.4053 1.37296 10.1449 0.876119 9.91696 0.488502C9.89965 0.459973 9.8661 0.445216 9.83251 0.450136C7.98895 0.755121 6.22475 1.28933 4.57857 2.01539C4.56431 2.02129 4.5521 2.03113 4.54399 2.04392C1.19769 6.84591 0.280993 11.5299 0.730692 16.1558C0.732726 16.1784 0.745953 16.2001 0.764266 16.2138C2.97206 17.7712 5.11069 18.7166 7.20961 19.3433C7.2432 19.3532 7.27879 19.3414 7.30017 19.3148C7.79667 18.6635 8.23925 17.9768 8.61872 17.2547C8.64112 17.2124 8.61974 17.1622 8.57397 17.1455C7.87196 16.8897 7.2035 16.5778 6.56049 16.2237C6.50963 16.1951 6.50556 16.1253 6.55235 16.0918C6.68766 15.9944 6.82301 15.8931 6.95221 15.7908C6.97559 15.7721 7.00816 15.7681 7.03565 15.7799C11.2599 17.6325 15.8332 17.6325 20.0077 15.7799C20.0352 15.7671 20.0678 15.7711 20.0922 15.7898C20.2214 15.8921 20.3567 15.9944 20.493 16.0918C20.5398 16.1253 20.5368 16.1951 20.4859 16.2237C19.8429 16.5847 19.1744 16.8897 18.4714 17.1445C18.4256 17.1612 18.4053 17.2124 18.4277 17.2547C18.8153 17.9758 19.2579 18.6625 19.7452 19.3138C19.7656 19.3414 19.8022 19.3532 19.8358 19.3433C21.9449 18.7166 24.0835 17.7712 26.2913 16.2138C26.3106 16.2001 26.3228 16.1794 26.3249 16.1567C26.8631 10.8087 25.4234 6.16315 22.5085 2.04489C22.5014 2.03113 22.4892 2.02129 22.475 2.01539ZM9.24955 13.3391C7.97775 13.3391 6.92982 12.2176 6.92982 10.8402C6.92982 9.46285 7.95743 8.34133 9.24955 8.34133C10.5518 8.34133 11.5896 9.4727 11.5693 10.8402C11.5693 12.2176 10.5416 13.3391 9.24955 13.3391ZM17.8264 13.3391C16.5546 13.3391 15.5067 12.2176 15.5067 10.8402C15.5067 9.46285 16.5342 8.34133 17.8264 8.34133C19.1287 8.34133 20.1664 9.4727 20.1461 10.8402C20.1461 12.2176 19.1287 13.3391 17.8264 13.3391Z"
										// fill="white"
									/>
								</svg>
								{/* <img src={Image.discord} alt="discord" /> */}
							</a>
							<a
								className="box"
								href="https://twitter.com/DegenDistillery"
								target="_blank"
							>
								<svg
									width="21"
									height="20"
									viewBox="0 0 21 20"
									fill="none"
									className="social_icon"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M0.604004 0.614254H6.54164L12.03 7.8325L18.8615 0.448853L20.4847 0.476419L12.8392 8.87089L20.68 19.1813H14.7447L9.56457 12.4547L3.23642 19.3468H1.63909L8.77884 11.4715L0.604004 0.614254ZM5.98176 1.68022H2.84591L15.3916 18.0878H18.471L5.98176 1.68022Z"
										// fill="white"
									/>
								</svg>
								{/* <img src={Image.cross} alt="cross" /> */}
							</a>
							<a
								className="box"
								href="https://opensea.io/collection/origo-origins"
								target="_blank"
							>
								<svg
									width="21"
									height="19"
									viewBox="0 0 21 19"
									fill="none"
									className="social_icon"
									xmlns="http://www.w3.org/2000/svg"
								>
									<path
										d="M15.5309 12.9957C15.0128 13.6899 13.9229 14.8426 13.3167 14.8426H10.4993V12.9942H12.7433C13.0643 12.9942 13.3704 12.8643 13.5914 12.6358C14.744 11.4414 15.41 10.02 15.41 8.49555C15.41 5.89463 13.466 3.59531 10.4978 2.20974V0.967508C10.4978 0.432989 10.0648 0 9.53025 0C8.99573 0 8.56275 0.432989 8.56275 0.967508V1.48262C7.73111 1.23925 6.8502 1.05411 5.93047 0.948098C7.4534 2.60242 8.38358 4.81514 8.38358 7.24138C8.38358 9.41678 7.64003 11.4145 6.39033 12.9972H8.56275V14.8486H5.38251C4.95251 14.8486 4.60313 14.5007 4.60313 14.0692V13.2599C4.60313 13.1181 4.48816 13.0016 4.34483 13.0016H0.152295C0.0701766 13.0016 2.54974e-06 13.0688 2.54974e-06 13.1509C-0.00298359 16.4626 2.61735 18.9485 5.7513 18.9485H14.5977C16.7179 18.9485 17.666 16.2311 18.9082 14.5022C19.3905 13.8333 20.5476 13.2958 20.8985 13.1465C20.9627 13.1196 21 13.0599 21 12.9897V11.9147C21 11.8057 20.8925 11.7236 20.7865 11.7534C20.7865 11.7534 15.6727 12.9285 15.613 12.9449C15.5533 12.9628 15.5309 12.9972 15.5309 12.9972V12.9957Z"
										// fill="white"
									/>
									<path
										d="M6.74582 7.23394C6.74582 5.56618 6.17397 4.03131 5.21841 2.81744L0.40625 11.1443H5.58272C6.3188 10.0215 6.74731 8.67773 6.74731 7.23543L6.74582 7.23394Z"
										// fill="white"
									/>
								</svg>

								{/* <img src={Image.boat} alt="cross" /> */}
							</a>
						</div>
						<div className="copy-right">
							<p>Degen Labs &copy; {getCurrentYear}</p>
						</div>
					</div>
				</div>
			</nav>
		</aside>
	);
};

export default SideMenu;
